import React from 'react'
import Box from '@mui/material/Box'
import ImageIcon from '@mui/icons-material/Image';
import { useTheme } from '@mui/material/styles';

export default function ImagePlaceholder({boxSx, iconSx}) {
    const theme = useTheme();

    return (
        <Box sx={{
            display: "flex",
            width: "100%",
            height: "100%",
            alignItems: "center",
            justifyContent: "center",
            ...boxSx
        }}>
            <ImageIcon fontSize="large" sx={{
                color: theme.palette.text.disabled,
                width: "75px",
                height: "75px",
                ...iconSx
            }}/>
        </Box>
    )
}
